import { userSelfGetApi } from "../../api/user/userSelfGetApi"

export async function userSelfGetService(token: string) {
	const { user, company } = await userSelfGetApi({ include: { company: true } }, token)
	if (company === undefined) throw new Error("Unable to fetch user's company details")
	return { user, company }
}
